import { colors, mixin } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { innerCellHorizontalPadding } from "./Styles"

export const BaseInputContent = styled.div<{ hasFocus: boolean }>`
  height: 100%;
  padding: 0 ${innerCellHorizontalPadding};
  display: flex;
  align-items: baseline;
  gap: 0.5rem;

  ${mixin.fieldBorder("transparent")};

  &:hover {
    background-color: ${colors.backgroundWhite};
  }

  position: relative;

  ${({ hasFocus }) =>
    hasFocus &&
    css`
      background-color: ${colors.backgroundWhite};

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0px;
        bottom: 1px;
        width: 100%;
        ${mixin.fieldBorder(colors.borderInputFocus)};
      }
    `}
`

export const BaseInputPrefix = styled.div`
  margin-left: -0.25rem;
  pointer-events: none;
  color: ${colors.textLight};
`

export const BaseInput = styled.input`
  width: 100%;
  height: 100%;
  padding: 0;

  background-color: transparent;
  color: ${colors.textDark};
  border: none;
  outline: 1px solid transparent;

  ${mixin.noWrapEllipsis};

  ::placeholder {
    color: ${colors.textLight};
  }
`
